export const AI_CHAT_ROUTE = "/ai-chat";

export const AI_CHAT_DISCLAIMER =
  "AI responses can be inaccurate. Please verify clinical information.";

export const AI_CHAT_EMPTY_DISCLAIMER =
  "AI can make mistakes. Consider verifying important clinical information.";

export const AI_CHAT_INPUT_PLACEHOLDER = "Ask AI Assistant anything...";

export const AI_CHAT_EMPTY_INPUT_PLACEHOLDER = "Ask AI Assistant...";

/** Initial POST /chat attempt plus automatic retries before showing inline error UI. */
export const AI_CHAT_MAX_ATTEMPTS = 3;

export const AI_CHAT_SEND_ERROR_TITLE = "Something went wrong";
export const AI_CHAT_SEND_ERROR_MESSAGE =
  "We couldn't get a response right now. Please try again in a moment.";
